import { Component } from '@angular/core';
import { AEmptyBasePage } from '../empty.base.page';

@Component({
    selector: 'app-empty-data',
    templateUrl: '../empty.base.page.html',
    styleUrls: ['../empty.base.page.css']
})
export class EmptyDataPage extends AEmptyBasePage {
    constructor() {
        super();
        this.pageTitleKey = '@@DataSettingsPageTitle';
        this.pageDescriptionKey = '@@DataSettingsPageDescription';
        this.settingItems = [
            {
                icon: 'pi pi-database',
                titleKey: '@@CreateNewDataModel',
                descriptionKey: '@@CreateNewDataModelDesc',
                link: '/settings/data/dataModel/dm-overview'
            },
            {
                icon: 'pi pi-table',
                titleKey: '@@ManageDataObjects',
                descriptionKey: '@@ManageDataObjectsDesc',
                link: '/settings/data/dataModel/dm-overview'
            },
            {
                icon: 'pi pi-code',
                titleKey: '@@ScriptLibrary',
                descriptionKey: '@@ScriptLibraryDesc',
                link: '/settings/data/scriptlibrary'
            },
            {
                icon: 'pi pi-sitemap',
                titleKey: '@@CreateServiceWorkflows',
                descriptionKey: '@@CreateServiceWorkflowsDesc',
                link: '/settings/data/workflow/wf-service'
            },
            {
                icon: 'pi pi-file-export',
                titleKey: '@@OutputTemplates',
                descriptionKey: '@@OutputTemplatesDesc',
                link: '/settings/data/output'
            },
            {
                icon: 'pi pi-clock',
                titleKey: '@@Scheduler',
                descriptionKey: '@@SchedulerDesc',
                link: '/settings/data/scheduler'
            },
            {
                icon: 'pi pi-cog',
                titleKey: '@@GlobalVariables',
                descriptionKey: '@@GlobalVariablesDesc',
                link: '/settings/data/globalvariable'
            },
            {
                icon: 'pi pi-cloud',
                titleKey: '@@CustomREST',
                descriptionKey: '@@CustomRESTDesc',
                link: '/settings/data/customrest'
            },
            {
                icon: 'pi pi-link',
                titleKey: '@@Connector',
                descriptionKey: '@@ConnectorDesc',
                link: '/settings/data/connector/connector-overview'
            }
        ];
    }
}
